function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 32,
  fill: "#FF6A00",
  opacity: 0.2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 24.907a3 3 0 013-3h4.7a3 3 0 002.36-1.148l.478-.61A3 3 0 0128.898 19h6.203a3 3 0 012.36 1.148l.48.61a3 3 0 002.36 1.149H45a3 3 0 013 3V41a3 3 0 01-3 3H19a3 3 0 01-3-3V24.907z",
  fill: "#FF6A00"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.87,
  cx: 32,
  cy: 33.207,
  r: 6.642,
  fill: "#fff"
});

function SvgScreenshot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIG9wYWNpdHk9IjAuMiI+CjxyZWN0IHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgcng9IjMyIiBmaWxsPSIjRkY2QTAwIi8+CjwvZz4KPHBhdGggZD0iTTE2IDI0LjkwN0MxNiAyMy4yNTAxIDE3LjM0MzEgMjEuOTA3IDE5IDIxLjkwN0gyMy42OTkxQzI0LjYyMDUgMjEuOTA3IDI1LjQ5MDggMjEuNDgzNiAyNi4wNTk1IDIwLjc1ODZMMjYuNTM4MiAyMC4xNDgzQzI3LjEwNjkgMTkuNDIzNCAyNy45NzcyIDE5IDI4Ljg5ODYgMTlIMzUuMTAxNEMzNi4wMjI4IDE5IDM2Ljg5MzEgMTkuNDIzNCAzNy40NjE4IDIwLjE0ODNMMzcuOTQwNSAyMC43NTg2QzM4LjUwOTIgMjEuNDgzNiAzOS4zNzk1IDIxLjkwNyA0MC4zMDA5IDIxLjkwN0g0NUM0Ni42NTY5IDIxLjkwNyA0OCAyMy4yNTAxIDQ4IDI0LjkwN1Y0MUM0OCA0Mi42NTY5IDQ2LjY1NjkgNDQgNDUgNDRIMTlDMTcuMzQzMSA0NCAxNiA0Mi42NTY5IDE2IDQxVjI0LjkwN1oiIGZpbGw9IiNGRjZBMDAiLz4KPGNpcmNsZSBvcGFjaXR5PSIwLjg3IiBjeD0iMzIiIGN5PSIzMy4yMDc0IiByPSI2LjY0MTUxIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgScreenshot as ReactComponent };